import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-key",
  templateUrl: "./field-set-key.component.html",
  styles: [],
})
export class FieldSetKeyComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

}
